/**
 * Order fields for mapping to Magento (API-level + practical required).
 */
import type { SkuProductFieldOption } from './product-field-mapping.types';

const I18N_PREFIX = 'onlineStore.form.order_field_mapping.order_fields';

export const DEFAULT_ORDER_FIELDS: SkuProductFieldOption[] = [
  { code: 'orderNo', labelKey: `${I18N_PREFIX}.order_no`, required: true },
  { code: 'orderStatus', labelKey: `${I18N_PREFIX}.order_status`, required: true },
  { code: 'customerName', labelKey: `${I18N_PREFIX}.customer_name`, required: true },
  { code: 'customerPhone', labelKey: `${I18N_PREFIX}.customer_phone` },
  { code: 'customerEmail', labelKey: `${I18N_PREFIX}.customer_email`, required: true },
  { code: 'totalAmount', labelKey: `${I18N_PREFIX}.total_amount`, required: true },
  { code: 'orderDate', labelKey: `${I18N_PREFIX}.order_date`, required: true },
  { code: 'shippingAddress', labelKey: `${I18N_PREFIX}.shipping_address`, required: true },
  { code: 'billingAddress', labelKey: `${I18N_PREFIX}.billing_address`, required: true },
  { code: 'paymentMethod', labelKey: `${I18N_PREFIX}.payment_method`, required: true },
  { code: 'shippingMethod', labelKey: `${I18N_PREFIX}.shipping_method`, required: true },
  { code: 'currencyCode', labelKey: `${I18N_PREFIX}.currency_code`, required: true },
  { code: 'remark', labelKey: `${I18N_PREFIX}.remark` },
  { code: 'sellerNote', labelKey: `${I18N_PREFIX}.seller_note` },
];

export const DEFAULT_REQUIRED_ORDER_FIELD_CODES = DEFAULT_ORDER_FIELDS.filter((f) => f.required).map((f) => f.code);
